import { parse } from 'date-fns'

export const getMonthIndex = (date: string, dateFormat: string) => {
  try {
    return parse(date, dateFormat, new Date()).getMonth() + 1
  } catch (error) {
    console.error(error)
    return null
  }
}
